module.exports = __webpack_public_path__ + "static/data_security-1f1da8b3e3cec8690d5874e8774030f5.png";